var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPaperPlaneTilt = function SvgIconPaperPlaneTilt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.44 2.404a1.74 1.74 0 0 1 2.156 2.155l-4.92 17.469a1.75 1.75 0 0 1-3.276.266l-3.756-7.938L1.706 10.6a1.75 1.75 0 0 1 .266-3.276l.005-.001zm.108 2.048L3.15 9.07l7.037 3.329 3.741-3.741a1 1 0 0 1 1.415 1.414L11.6 13.814l3.33 7.037zM2.542 8.783l.003.002z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPaperPlaneTilt;